<template>
    <div class="card mb-3 bg-blur">
        <div class="d-flex no-gutters">
            <div class="col img-column">
                <img :src="book.cover_url.replace(/\.webp$/, '_thumb.webp') + '?' + book.cover_hash" class="mx-auto d-block cover" v-if="book.cover_url" />
                <img v-lazy="cover()" class="mx-auto d-block cover" v-else />
                <span class="badge badge-rating" :class="['badge-' + book.rating.color]" v-if="book.rating">
                    <i class="fas fa-eye-slash" v-if="book.is_hidden" title="ポータル非表示"></i>
                    {{book.rating.rating_name}}
                </span>
            </div>
            <div class="col">
                <div class="card-body p-2">
                    <div class="d-flex flex-wrap flex-lg-nowrap justify-content-between">
                        <div class="d-flex flex-row">
                            <div class="ml-2">
                                <div class="card-title">
                                    <div class="small">
                                        <span v-if="book.series">
                                            {{book.series.series_name}}
                                            <i class="fas fa-layer-group" v-if="book.series.is_group"></i>
                                        </span>
                                        <span v-else>&ensp;</span>
                                    </div>
                                    <router-link :to="`/mypage/book/${book.id}/sections/`" class="black">
                                        <h4 class="title mincho" v-html="$filters.ruby(book.title)"></h4>
                                    </router-link>
                                    <span class="badge badge-secondary" v-if="!book.is_long">短編</span>
                                </div>
                                <h6 class="card-subtitle mincho" v-if="book.subtitle" v-html="$filters.ruby(book.subtitle)"></h6>
                            </div>
                        </div>
                        <div class="pt-4">
                            <div class="d-flex justify-content-between btn-novel">
                                <router-link :to="`/mypage/book/${book.id}/sections/`" class="btn btn-link text-success">
                                    <i class="fas fa-list"></i>
                                    本文
                                    {{book.episodes_count}} 話
                                </router-link>
                                <router-link :to="`/mypage/book/${book.id}/edit/`" class="btn btn-link">
                                    <i class="fas fa-edit"></i>
                                    小説
                                </router-link>
                                <router-link :to="`/mypage/book/${book.id}/notes/edit`" class="btn btn-link text-warning">
                                    <i class="far fa-sticky-note"></i>
                                    ノート
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="mt-2 ml-2 d-flex flex-wrap justify-content-between small">
                        <div>
                            <span v-if="book.property.is_finished" class="badge badge-dark badge-pill">完結</span>
                            <span v-else class="badge badge-primary badge-pill">連載中</span>
                            <span v-if="!book.genre_id" class="badge badge-secondary badge-pill">ジャンルなし</span>
                            <span v-else class="badge badge-dark badge-pill">{{book.genre.genre_name}}</span>
                        </div>
                        <ul class="horizontal-list mr-75">
                            <li :class="{'text-danger': book.property.characters == 0}">{{$filters.numberFormat(book.property.characters)}} 文字</li>
                            <li v-if="book.property.last_published_at">{{$filters.dateFormat(book.property.last_published_at, 'YYYY年MM月DD日')}} 最終更新</li>
                            <li v-else class="text-danger">未公開</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<style scoped lang="scss">
.cover {
    object-fit: cover;
    height: 100%;
    width: 83px;
    position: relative;
}
.img-column {
    max-width: 83px;
}
.badge {
    font-size: .7rem;
}
.badge-rating {
    position: absolute;
    left: .5rem;
    top: .5rem;
}
.btn-novel {
    margin: .25rem;
    .btn {
        font-size: .7rem;
    }
}
.title {
    display: inline-block;
    margin-bottom: 0;
    font-size: 1.15rem;
}
.card-subtitle {
    font-weight: normal;
    font-size: .7rem;
}
.card {
    overflow: hidden;
}
.btn {
    white-space: nowrap;
}
.desc {
    max-width: 480px;
    text-align: left;
    margin: 1rem auto;
}
.mr-75 {
    margin-right: .75rem;
}
@media screen and (max-width: 770px) {
    .container {
        padding: 0;
    }
    .btn-novel {
        display: block;
    }
}
</style>

<script>
export default {
    props: {
        book: {
            require: true
        }
    },
    methods: {
        cover() {
            const index = Math.floor(Math.random() * this.$store.getters.novelCovers.length);
            return this.$store.getters.novelCovers[index];
        },
    }
}
</script>